<template>
  <div class="mapworld">
    <ul class="texts">
      <li>
        <p>{{$t('map.num1')}}</p>
        <div>{{$t('map.datacity')}}</div>
      </li>
      <li>
        <p>{{$t('map.num2')}}</p>
        <div>{{$t('map.datacenter')}}</div>
      </li>
      <li>
        <p>{{$t('map.num3')}}</p>
        <div>{{$t('map.dataport')}}</div>
      </li>
    </ul>
    <div
      id="earth"
      ref="myEchart"
    ></div>
    <div class="displ">
      <ul>
        <li>{{$t('map.tips')}}</li>
        <li>• {{$t('map.tipsone')}}</li>
        <li>• {{$t('map.tipstwo')}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import "../../../node_modules/echarts/map/js/china.js";
// import "../../../node_modules/echarts/map/js/world.js";
export default {
  props: {
    newdata: Array,
    startSt: Number,
    first: Number
  },
  data() {
    return {
      mapdatas: this.$t('mapworld.mapdatas'),
      mapdatanew: this.$t('mapworld.mapdatanew'),
      data: this.$t('mapworld.data'),
      GZData: []
    };
  },
  created() {
    console.log(this.startSt);
    console.log(this.first);
  },
  watch: {
    startSt: function(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal > 15) {
        this.mapdatas = this.newdata;
        console.log(this.mapdatas);
        this.initEcharts();
      } else if (5 < newVal < 15) {
        this.mapdatas = this.newdata;
        console.log(this.mapdatas);
        this.initEcharts();
      }
      if (newVal < 5) {
        this.mapdatas = this.mapdatanew;
        console.log(this.mapdatas);
        this.initEcharts();
      }
    },
    first: function(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (50 > newVal > 15) {
        this.mapdatas = this.newdata;
        console.log(this.mapdatas);
        this.initEcharts();
      } else if (5 < newVal < 15) {
        this.mapdatas = this.newdata;
        console.log(this.mapdatas);
        this.initEcharts();
      }
      if (newVal < 5) {
        this.mapdatas = this.mapdatanew;
        console.log(this.mapdatas);
        this.initEcharts();
      }
    }
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      let geoCoordMap = this.$t('geoCoordMap');
      if (this.startSt > 5 || this.first > 5) {
        var arr1 = []; //一维数组
        var arr2 = []; //二维数组
        var arr3 = []; //三维数组
        arr1[0] = 0;
        arr2[0] = arr1;
        arr3[0] = arr2;
        arr3[0][0][0] = this.mapdatas[0];
        arr3[0][0][1] = this.mapdatas[1];
        this.GZData = arr3;
        console.log(arr3);
      } else {
        this.GZData = this.$t('GZData');
      }
      // 发射点数组下标
      let launchIndex = 0;
      // 按照数组顺序循环发射（如果是使用定时器销毁重建图形发射点那么这个就派上用场了）
      let len = this.GZData.length;
      let arrIndex = launchIndex;
      if (launchIndex < len - 1) {
        launchIndex = launchIndex + 1;
      } else {
        launchIndex = 0;
      }
      // 防止切换用户列表时，定时器延迟造成下标超出数组问题
      if (arrIndex > len - 1) {
        launchIndex = 0;
        arrIndex = 0;
      }
      // 数组遍历
      let lineDataArr = [];
      lineDataArr.push(this.GZData[arrIndex]);
      console.log(lineDataArr);
      // 处理线路所需要的数据格式data
      let convertData = function(data) {
        console.log(data);
        let res = [];
        for (let i = 0; i < data.length; i++) {
          let dataItem = data[i];
          let fromCoord = geoCoordMap[dataItem[0].name];
          let toCoord = dataItem[1]
            ? geoCoordMap[dataItem[1].name]
            : dataItem[0].name;
              console.log(fromCoord)
             console.log(toCoord)
          if (fromCoord && toCoord) {
            res.push({
              fromName: dataItem[0].name,
              toName: dataItem[1] ? dataItem[1].name : dataItem[0].name,
              coords: [fromCoord, toCoord]
            });
          }
        }
        return res;
      };
      // 发射点和线路颜色
      let color = ["#ffa022", "#a6c84c", "#46bee9"]; // 橙 墨绿 蓝
      var planePath =
        "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z";
      let seriesData = [];
      lineDataArr.forEach(function(item, i) {
         console.log(item)
        seriesData.push(
          // 亮光发射效果
          {
            name: item[0],
            type: "lines",
            zlevel: 1,
            label: {
              show: true
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 0
              }
            },
            silent: true,
            data: convertData(item)
          },
          // 线路效果
          {
            name: item[0],
            type: "lines",
            zlevel: 2,
            effect: {
              show: true,
              period: 4,
              trailLength: 0,
              symbol: "pin",
              symbolSize: 8
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 1,
                opacity: 0.6,
                curveness: 0.35
              }
            },
            silent: true,
            data: convertData(item)
          }
        );
      });
      var mychartMap = this.$echarts.init(this.$refs.myEchart);
      mychartMap.setOption({
        // 标志颜色
        color: "rgb(255, 174, 64)",
        geo: {
          map: "china",
          show: true,
          roam: false, //是否缩放
          layoutSize: 1200,
          label: {
            show: false
          },
          zoom: 1.2,
          itemStyle: {
            borderColor: "rgb(255, 115, 76)",
            borderWidth: 2,
            areaColor: "rgb(0, 109, 84)",
            shadowBlur: 0
          },
          silent: true //图形是否不响应和触发鼠标事件
        },
        // hover显示目标数据
        tooltip: {
          show: true,
          trigger: "item",
          textStyle: {
            align: "left",
            color: "#1d5a33"
          },
          backgroundColor: "#fff",
          borderColor: "#1d5a33",
          borderWidth: "1",
          extraCssText: "border-radius:8px",
          formatter: function(params) {
            console.log(params);
            return params.name + " <br /> " + params.data.data;
          }
        },
        series: [
          ...seriesData, // 中国地图线路特效配置
          {
            name: "", //名称
            type: "effectScatter",
            mapType: "china",
            coordinateSystem: "geo", // series坐标系类型
            symbolSize: 5,
            legendHoverLink: true,
            effectType: "ripple",
            showEffectOn: "render",
            rippleEffect: {
              scale: 7
            },
            data: this.mapdatas,
            label: {
              show: false, //名称显示
              formatter: function(params) {
                return params.name;
              },
              textStyle: {
                color: "rgb(173, 216, 235)",
                align: "left",
                fontSize: 10,
                padding: [0, 0, 0, 10]
              }
            },
            emphasis: {
              show: false
            },
            itemStyle: {
              borderColor: "rgb(236, 238, 240)"
            }
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mapworld {
  .texts {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 90px 30px 90px;
    box-sizing: border-box;
    li {
      color: #1d5a33;
      p {
        font-size: 49px;
        font-weight: 700;
      }
      div {
        font-size: 21px;
      }
    }
  }
  .displ {
    margin-left: 40px;
    // margin-top:20px;
    text-align: left;
    position: absolute;
    bottom: 20px;
    li {
      text-align: left;
      line-height: 27px;
    }
  }
  #earth {
    width: 680px;
    height: 460px;
    text-align: center;
    // background-size: 100% 100%;
    // background:url('../../assets/img/price/china.png') no-repeat center center;
  }
}
</style>
